import { render, staticRenderFns } from "./RecommendedProductsCarousel.vue?vue&type=template&id=1256b7ce&"
import script from "./RecommendedProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./RecommendedProductsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports